import { $workspaceInitData } from './states';
import { fetchWorkspaceByKey } from './effects';

// Fetch workspace init data by key
$workspaceInitData.on(fetchWorkspaceByKey.doneData, (_, data) => data);
